exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1QvIBaxI0h{display:-ms-flexbox;display:flex;font-size:14px}._3hgqMfJ1pB{font-weight:700;text-decoration:none;color:inherit}._3hgqMfJ1pB:hover{color:#2ab8d5}.g75yLMtYaV{margin-right:15px}._2tSRikxEF4{width:100%}.RbT9Lwdoec{font-size:14px;color:#8c96a5}._1QM0T8_oKN,._2_K8Ub9KL2{font-size:9pt;color:#8c96a5}._1QM0T8_oKN:before{content:\" | \"}._2_K8Ub9KL2{display:inline-block;vertical-align:middle;margin-left:10px}._396MWsiZma{margin-bottom:5px}._1Wil9y15Uo{margin-top:5px}", ""]);

// exports
exports.locals = {
	"main": "_1QvIBaxI0h",
	"header": "_396MWsiZma",
	"username": "_3hgqMfJ1pB",
	"avatar": "g75yLMtYaV",
	"body": "_2tSRikxEF4",
	"program": "RbT9Lwdoec",
	"ts": "_1QM0T8_oKN",
	"ratingText": "_2_K8Ub9KL2",
	"footer": "_1Wil9y15Uo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/components/Review/Review.scss
// module id = 960
// module chunks = 20 21